import { UI_API_METHOD_TYPES } from '@sdk/api/modules/ui/types.ui'
import { usePostRobot } from '@lib/sdk/utils/postrobot'
import type { UpdateLocationPitcherEvent } from '@sdk/interfaces'
import { getTopPitcherWindow } from '@sdk/utils/window'

/**
 * Navigate to another page in the CatalogIQ instance.
 *
 * [//]: # 'TODO: This is a very powerful event, we need to expand documentation here'
 *
 * @example
 * const canvasId = '1234567890abcdef12345678' // obtain target canvasId
 * useUi().updateLocation({
 *   action: 'restore',
 *   routes: {
 *     'slotty-ui': {
 *       path: '/canvases/saved-canvases/' + canvasId + '/build/present',
 *       query: {},
 *     },
 *   },
 * })
 */

export async function updateLocation(payload: UpdateLocationPitcherEvent): Promise<any> {
  const pr = await usePostRobot()
  return pr.send(getTopPitcherWindow(), UI_API_METHOD_TYPES.UI_UPDATE_LOCATION, payload)
}
